/**
 * 集中处理使用mock数据还是真实数据
 */
import axios from 'axios';
import request from '@/utils/request';
import store from '@/store';

const config = require('../../config/api.env');

const urls = {
  common: require('./common').default,
  auth: require('./auth').default,
  user: require('./user').default,
  userGroup: require('./userGroup').default,
  role: require('./role').default,
  permission: require('./permission').default,
  corporation: require('./corporation').default,
  device: require('./device').default,
  project: require('./project').default,
  structure: require('./structure').default,
  measuringPoint: require('./measuringPoint').default,
  measuringAttribute: require('./measuringAttribute').default,
  report: require('./report').default,
  operationLog: require('./operationLog').default,
  monitor: require('./monitor').default,
  bim: require('./bim').default,
  bimTag: require('./bimTag').default,
  alertRule: require('./alertRule').default,
  alert: require('./alert').default,
  stat: require('./stat').default,
  live: require('./live').default,
  sgbj: require('./sgbj').default,
  pushStrategy: require('./pushStrategy').default,
  chartSetting: require('./chartSetting').default,
  shift: require('./shift').default,
};

const apiType = config.API_TYPE;

// 全局loading在这里设置好
const MOCK_ON = process.env.VUE_APP_MOCK_ON === '1';

const item2Function = (item) => {
  if (MOCK_ON && item.mock) {
    return (params) => {
      return axios.get(item.mock, params).then(rs => rs.data);
    };
  } if (item.server) {
    return (params, options = {
      showLoading: true,
      isFormData: false,
      config: {},
    }) => {
      if (options.showLoading === undefined) options.showLoading = true;
      if (options.config === undefined) options.config = {};
      if (options.showLoading) {
        store.commit('setLoading', true);
      }
      let dataKey = 'data';

      if (item.method && (item.method.toLowerCase() === 'get' || item.method.toLowerCase() === 'delete')) {
        dataKey = 'params';
      }
      const matchKeys = item.server.match(/\{\w+\}/g);
      let server = item.server;
      if (matchKeys && params) {
        Object.keys(params).forEach((key) => {
          if (matchKeys.includes(`{${key}}`)) {
            server = server.replace(`{${key}}`, params[key]); // 参数替换
            delete params[key];
          }
        });
      }
      let url;
      if (~server.indexOf('/static/') || ~server.indexOf('://')) {
        url = `${server}`; // 对应代理的/api
      } else {
        url = `/${apiType}${server}`; // 对应代理的/api
      }

      let formDataParams;
      // post请求，参数处理成formData格式
      if (options.isFormData) {
        formDataParams = new FormData();
        Object.keys(params).forEach((prop) => {
          formDataParams.append(prop, params[prop]);
        });
      }

      return request({
        url,
        [dataKey]: options.isFormData ? formDataParams : params,
        method: item.method ? item.method : 'get',
      }).then((rs) => {
        return rs;
      }).catch((err) => {
        // 往外抛异常，而不是返回，不然会提示请求成功
        throw err;
      }).finally(() => {
        if (options.showLoading !== false) store.commit('setLoading', false);
      });
    };
  }
  return () => {
    console.error('接口未定义');
  };
};

// eslint-disable-next-line no-shadow
const tranUrls = (urls) => {
  const apis = {};
  Object.keys(urls).forEach((v) => {
    apis[v] = urls[v].mock || urls[v].server ? item2Function(urls[v]) : tranUrls(urls[v]);
  });
  return apis;
};
const api = tranUrls(urls);

// if (process.env.NODE_ENV === 'production') {
//   for (let url in Object.keys(urls)) {

//   }
// } else {
//   for (let api in Object.keys(api)) {

//   }
// }
export default api;

export const apiInstall = {
  install(Vue) {
    Vue.prototype.$api = api;
    Vue.prototype.$apiType = apiType;
  },
};

